import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import TextButton from 'LuxKit/Button/TextButton'
import Typography from 'LuxKit/Typography/Typography'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import { useEffect, useRef } from 'react'
import { useIntl } from 'react-intl'
import clsx from 'clsx'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import LoyaltyLandingPageBenefitsTable from './LoyaltyLandingPageBenefitsTable'
import { useLocation } from 'react-router'

const Section = styled(Pane)`
  padding: ${rem(24)} 0;
  scroll-margin-top: 80px;

  ${mediaQueryUp.tablet} {
    padding: ${rem(48)} 0;
  }

  &.compact {
    padding-top: ${rem(36)};
    padding-bottom: ${rem(48)};
  }
`

interface Props {
  highlightTier?: App.LoyaltyTier
  onJoin?: () => void
  ctaLink?: string
  ctaText?: string
  compact?: boolean
}

function LoyaltyLandingPageBenefitsTableSection(props: Props) {
  const intl = useIntl()
  const defaultCtaText = intl.formatMessage({
    id: 'l3C4sGDjCxLM4vnEnR5n',
    defaultMessage: 'Join now - it’s free',
    description: 'Default call-to-action button text to join the free loyalty program',
  })
  const { highlightTier, onJoin, ctaLink, ctaText = defaultCtaText, compact } = props
  const sectionRef = useRef<HTMLDivElement>(null)
  const location = useLocation()

  const showCta = onJoin || ctaLink

  useEffect(() => {
    if (location.hash === '#about-benefits' && sectionRef.current) {
      sectionRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }
  }, [location.hash])

  return <Section ref={sectionRef} id="about-benefits" paletteType="inverse" className={clsx({ compact })}>
    <LayoutContainer variant="medium">
      <Group direction="vertical" gap={compact ? 12 : 72}>
        <LoyaltyLandingPageBenefitsTable highlightTier={highlightTier} />
        {showCta && <Typography align="center">
          <TextButton
            kind="primary"
            onClick={onJoin}
            to={ctaLink}
          >
            {ctaText}
          </TextButton>
        </Typography>}
      </Group>
    </LayoutContainer>
  </Section>
}

export default LoyaltyLandingPageBenefitsTableSection
